import React from 'react';
import { Flag } from '@prism/indicator';

class PrismIndicatorFlag extends React.PureComponent {
    render() {
        return (
            <div className="prism-sandbox">
                <Flag {...this.props} />
            </div>
        )
    }
}

PrismIndicatorFlag.propTypes = { ...Flag.propTypes };
PrismIndicatorFlag.defaultProps = { ...Flag.defaultProps };

export default PrismIndicatorFlag;
